import Image from 'core/image';
import LeftIcon from 'core/icons/left-icon';
import PropTypes from 'prop-types';
import styles from 'styles/Insurace.module.scss';
import { useTranslations } from 'next-intl';
import variables from 'styles/variables.module.scss';

export const NextArrow = ({ sliderRef }) => {
    return (
        <div
            className={styles.arrowContainer}
            onClick={() => sliderRef.current.slickPrev()}
        >
            <LeftIcon
                fill={variables.primaryColor}
                width="30px"
                height="30px"
                style={{ transform: 'rotate(180deg)' }}/>
        </div>
    );
};

NextArrow.propTypes = {
    sliderRef: PropTypes.any
};

export const PrevArrow = ({ sliderRef }) => {
    return (
        <div
            className={styles.arrowContainer}
            onClick={() => sliderRef.current.slickNext()}
        >
            <LeftIcon
                fill={variables.primaryColor}
                width="30px"
                height="30px"/>
        </div>
    );
};

PrevArrow.propTypes = {
    sliderRef: PropTypes.any
};

export const SlidesItems = ({ logo }) => {
    const t = useTranslations('insurace');
    return (
        <div className={styles.slideItemContainer}>
            <Image
                alt={t('alt.insurer-icon')}
                src={logo}
                // width="550px"
                // height="350px"
            />
        </div>
    );
};

SlidesItems.propTypes = {
    logo: PropTypes.any
};
